module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "el-select-dropdown__item",
    class: {
      selected: _vm.itemSelected,
      'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
      hover: _vm.hover
    },
    on: {
      "mouseenter": _vm.hoverItem,
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectOptionClick.apply(null, arguments)
      }
    }
  }, [(_vm.multiple) ? _c('div', {
    staticClass: "checkbox"
  }, [(_vm.itemSelected) ? _c('rt-icon', {
    attrs: {
      "name": "rt-base-irregular-check-lined",
      "size": "12",
      "color": _vm.SCSS_VARIABLES.COLOR_TEXT_WHITE
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._t("default", function() {
    return [_c('span', [_vm._v(_vm._s(_vm.currentLabel))])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-512bbff0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/select/src/option.vue
// module id = 2087
// module chunks = 228